import produce from 'immer';
import { put, takeLatest } from 'redux-saga/effects';
import axios from 'utils/axios';
import { creator, errorMessageGenerator } from 'uwork-app-core';

/**
 * External Ations
 */
import { actions as alertActions } from 'sagas/app/alertSaga';

/**
 * Constants
 */
export const REQUEST = '@app/workers/orders/syncSalary/REQUEST';
export const SUCCESS = '@app/workers/orders/syncSalary/SUCCESS';
export const FAILURE = '@app/workers/orders/syncSalary/FAILURE';
export const CLEAR = '@app/workers/orders/syncSalary/CLEAR';

/**
 * Initial state
 */
const initState = {
    loading: false,
    error: '',
    success: false
};

/**
 * Defualt reducer
 *
 * @param state
 * @param action
 */
const reducer = (state = initState, { payload, ...action }) =>
    produce(state, (draft) => {
        switch (action.type) {
            case SUCCESS:
                draft.success = true;
                draft.loading = false;
                break;
            case FAILURE:
                draft.error = payload;
                draft.loading = false;
                break;
            case REQUEST:
                draft.loading = true;
                draft.success = false;
                draft.error = '';
                break;
            case CLEAR:
                draft.loading = false;
                draft.success = false;
                draft.error = '';
                break;
            default:
                break;
        }
    });
export default reducer;

/**
 * Redux actions
 */
export const actions = {
    request: (data) => creator(REQUEST, data),
    success: () => creator(SUCCESS),
    failure: (data) => creator(FAILURE, data),
    clear: () => creator(CLEAR)
};

/**
 * Sagas
 */
export const sagas = {
    *request({ payload }) {
        try {
            yield axios.put(`/orders/workers/sync-salary/${payload.orderId}`);
            yield put(actions.success());
            yield put(alertActions.success({ message: payload.message }));
        } catch (e) {
            console.error(e);
            const error = errorMessageGenerator(e);
            yield put(actions.failure(error));
        }
    }
};

/**
 * Saga watchers
 */
export const watcher = function* watch() {
    yield takeLatest(REQUEST, sagas.request);
};
